// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Structure_wrapper__1Fs_p","header":"Structure_header__kljRA","container":"Structure_container__PB49y","message":"Structure_message__2OChu"};